import React, { Fragment, useEffect, useState } from 'react'
// eslint-disable-next-line
import { getPlayListDetails, getSongDetailsById, getSimilarPlaylists, getSonglistURL } from '../../utils/api'
import { formatDate, httpToHttps } from '../../utils/helper-functions'
import { Pagination } from '../helpers/Pagination'
import { SongsList } from './SongsList'
import { Loading } from '../helpers/Loading'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { useTranslation } from 'react-i18next'
import { Link, withRouter } from 'react-router-dom'
import { ButtonIcons } from '../helpers/ButtonIcons'
// import { Toast } from '../helpers/Toast'

const PlaylistsDetails = ( props ) => {
  const id = props.match.params.id
  const [playList, setPlayList] = useState( {} )
  const [currentPage, setCurrentPage] = useState( 1 )
  const [totalResults, setTotalResults] = useState( 0 )
  const [resultsPerPage] = useState( 10 )
  const [tracks, setTracks] = useState( [] )
  const [loading, setLoading] = useState( false )
  const { i18n } = useTranslation( ['topCharts', 'chartlist'], { useSuspense: false } )
  // const [mssg, setMssg] = useState( false )
  // console.log( i18n?.options?.resources?.topCharts["en-US"], "i18n topCharts" )
  // console.log( props, "playListDetails props" )

  let mounted = true
  useEffect( () => {
    const playlistDetails = async () => {
      setLoading( true )
      const result = await getPlayListDetails( id )
      setPlayList( result.playlist )
      const songIDs = result?.playlist?.trackIds
      const ids = songIDs && songIDs.map( id => id.id )
      const tracksList = await getSongDetailsById( ids )
      const urlsArr = await getSonglistURL( ids )
      const tracksURL = tracksList?.map( track => {
        urlsArr?.map( url => {
          if ( url.id === track.id ) {
            track.url = url.url
            return url
          }
        } )
        return track
      } )
      // console.log( "playlist tracks/w URLs", tracksURL )
      if ( mounted ) {
        setTracks( tracksURL )
        setTotalResults( tracksList.length )
        setLoading( false )
      } else {
        setLoading( true )
      }
    }
    playlistDetails( id )
    return () => {
      mounted = false
    }
  }, [id] )
  // Get current songs
  const indexOfLastSong = currentPage * resultsPerPage
  const indexOfFirstSong = indexOfLastSong - resultsPerPage
  const currentSongs = tracks.slice( indexOfFirstSong, indexOfLastSong )
  const nextPage = ( pageNumber ) => setCurrentPage( pageNumber )
  // eslint-disable-next-line
  const { trackList, playTrack } = useMusicPlayer()
  let idx = props.location.index !== undefined ? props.location.index : props.location.i

  /** addTrack(track){
  let tracks = this.state.playlistTracks;
  let trackExists = tracks.filter(t=>{return t.id==track.id}); 
  //Check if already exists in array
  if(trackExists.length === 0){
      this.setState({
          playlistTracks: this.state.playlistTracks.push(track)
      });
  }
} */
  const addSongToPlayQueue = ( id ) => {
    let curr = currentSongs?.find( ( t ) => t.id === id )
    let index = trackList.findIndex( ( curr ) => curr?.id === id )
    // console.log( index, "index of trackList", id )
    if ( index === -1 ) {
      trackList?.push( { ...curr } )
    } else {
      // setMssg( true )
      return alert( "Already in Queue" )
    }
  }
  // console.log( trackList, "trackList to Queue", playList )
  return (
    <div className="playlists__wrapper">
      {loading ? <Loading />
        : <Fragment>
          <div className="playlists__details">
            <img
              src={httpToHttps( playList.backgroundCoverUrl !== null ? playList.backgroundCoverUrl : playList.coverImgUrl )}
              alt={playList.name}
              loading="lazy"
            />
            <br />
            <div className="details__info">
              {props.location.i === undefined && props.location.index === undefined
                ? <p>
                  {playList?.name !== null ? playList?.name : playList.englishTitle}
                </p>
                : <p key={props.location.key}>
                  {props.location.i === undefined ? i18n?.options?.resources?.toplist["en-US"][idx]?.name : i18n?.options?.resources?.chartlist['en-US'][idx]?.name}
                  {/* {console.log( props.location.i, "location/key", props.location.index )} */}
                </p>
              }
              <span>
                Created by:
                {console.log( playList?.name, playList )}
                <Link to={`/user/playlists/${playList?.creator?.userId}`}>
                  {playList?.creator?.nickname === "网易云音乐" ? "NetEase Cloud Music" : playList?.creator?.nickname}
                </Link>
                {formatDate( playList?.createTime ).substring( 0, 10 )}
              </span>
              <br />
              <span>
                Updated:
                {playList.trackUpdateTime && formatDate( playList.trackUpdateTime ).substring( 0, 10 )}
              </span>
              <br />
              <span>
                {playList.trackCount} {" "} Tracks
              </span>
              <p className="details__info desc">
                {/* {playList?.description} */}
              </p>
              <ButtonIcons />
            </div>
          </div>

          <article className="queue__wrapper">
            <table className="global__list">
              {currentSongs ? currentSongs.map( track => {
                let index = tracks.indexOf( track )
                return (
                  <SongsList
                    key={track.id}
                    track={track}
                    index={index}
                    addSongToPlayQueue
                    ={addSongToPlayQueue}
                  />
                )
              } ) : null}
            </table>
          </article>
          {totalResults > resultsPerPage
            ? <Pagination
              resultsPerPage={resultsPerPage}
              totalResults={totalResults}
              nextPage={nextPage}
            />
            : null}
        </Fragment>
      }
      {props.children}
    </div>
  )
}
export default withRouter( PlaylistsDetails )
/** {mssg === true ? <Toast mssg="Track Already in Queue" status="warning" />
: null} **/